module.exports = {
    en: {
        footer: {
            home: 'Home',
            news: 'News',
            mstrans: "MS Trans Lounge",
            catalog: "Catalogs",
            salesteam: "Sales team",
            customcl: "Get Customs clearance",
            vin: "VIN:search",
            hour: "Sale Hours",
            connect: "Connect With Us",
            dro1: "10:00AM - 07:00PM",
            dro2: "Saturday: 09:00AM - 07:00PM ",
            dro3: "Sunday: Closed",
        }

    },
    ka: {
        footer: {
            home: 'მთავარი',
            news: 'სიახლეები',
            mstrans: "MS Trans ლაუნჯი",
            catalog: "კატალოგები",
            salesteam: "გაყიდვების გუნდი",
            customcl: "განბაჟება",
            vin: "VIN:ძებნა",
            hour: "გაყიდვის საათები",
            connect: "დაკავშირება ჩვენთან",
            dro1: "10:00 - 19:00",
            dro2: "სატესტო",
            dro3: "სატესტო",
        }
    },
    ru: {
        footer: {
            home: 'основной',
            news: 'новости',
            mstrans: "MS Транс Лаундж",
            catalog: "каталоги",
            salesteam: "отдел продаж",
            customcl: "таможенное оформление",
            vin: "VIN:Поиск",
            hour: "Часы продаж",
            connect: "Свяжитесь с нами",
            dro1: "10:00 - 19:00",
            dro2: "тест",
            dro3: "тест",
        }
    }
}